"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewFlightIndicator = function NewFlightIndicator() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.499971 6.8173L1.67305 6.8173L3.11535 8.7596L8.79805 8.7596L6.35575 0.499999L7.89417\n0.499999L12.7788 8.7596L18.2692 8.7596C18.6153 8.7596 18.9086 8.87979 19.1489 9.12018C19.3893\n9.36056 19.5095 9.65382 19.5095 9.99998C19.5095 10.3461 19.3893 10.6394 19.1489 10.8798C18.9086\n11.1202 18.6153 11.2404 18.2692 11.2404L12.7788 11.2404L7.89417 19.5L6.35575 19.5L8.79805\n11.2404L3.13457 11.2404L1.67305 13.1827L0.499971 13.1827L1.42305 9.99997L0.499971 6.8173Z",
    fill: "#6E6D71"
  }));
};
var _default = NewFlightIndicator;
exports.default = _default;